import { render } from "./top_selling_products.vue?vue&type=template&id=68a0ea50"
import script from "./top_selling_products.vue?vue&type=script&lang=js"
export * from "./top_selling_products.vue?vue&type=script&lang=js"

import "./top_selling_products.vue?vue&type=style&index=0&id=68a0ea50&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__